import { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import MediaGalleryModal from './media-gallery-modal.component';
import MediaGalleryModalGateway from './media-gallery-modal-gateway.component';

const MediaGalleryMobile = (props) => {  

    const { allImages } = props;    
    const [currentIndex, setCurrentIndex] = useState(0);
    const [transformMediaValue, setTransformMediaValue] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    useEffect(() => {
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                toggleModal();
            }
        };  
        const updateBodyHeight = () => {           
            if (window.innerWidth <= 1366) {
            document.body.style.height = '5358px'; // Laptop size
            } else {
            document.body.style.height = '7792px'; // Wide screen size
            }
        };              
        if (isModalOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'relative';
            document.body.style.boxSizing = 'border-box';
            updateBodyHeight();
            document.body.style.paddingRight = '15px';
            document.addEventListener('keydown', handleEscapeKey);
        }
        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.boxSizing = '';
            document.body.style.height = '';
            document.body.style.paddingRight = '';
            document.removeEventListener('keydown', handleEscapeKey);
        };        
    }, [isModalOpen]);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
        
    const handleImageClick = (event) => {
        event.stopPropagation();
    };

    const renderGalleryModal = (images) => {
        return (
            <>                
                <MediaGalleryModalGateway target={document.body}>
                    {isModalOpen ? (
                        <MediaGalleryModal images={images} toggleModal={toggleModal} />
                    ) : null}
                </MediaGalleryModalGateway>
            </>
        );
    };     

    const renderGalleryButton = () => {        
        return (
            <div className='media-gallery-button-wrapper'>
                <Button
                    id="view-gallery-button"
                    type="button"
                    onClick={toggleModal}
                    startIcon={<img src="/assets/images/gallery_icon.png" alt="gallery_icon" />}
                >
                    View Gallery
                </Button>
            </div>
        );
    };

    const getNextImageSource = (imageNumber) => {        
        const images = [];
        _.forEach(allImages, (image, index) => {
            images.push({ source: image, id: index });
        });
        if (currentIndex + imageNumber < images.length) {
            return _.get(images[currentIndex + imageNumber], 'source');
        }
        return _.get(images[Math.abs(currentIndex - imageNumber)], 'source');
    };

    const renderCarouselItem = (images, wrapperWidth) => {
        return _.map(images, (image, index) => {
            return ( 
                <div className="media-gallery-image-wrapper" key={index} onClick={handleImageClick}
                    style={{
                        display: 'inline-block',
                        verticalAlign: 'top',
                        width: wrapperWidth,
                    }}>
                    <div className="media-gallery-image-view">
                        <img 
                            className='media-gallery-image-view-img'
                            src={image.source}
                            id={image.id}
                        />
                    </div>
                </div>
            );
        });
    };

    const renderGallery = (images) => {

        const MediaGalleryWith = 808;

        const goToNextImage = () => {
            if (currentIndex < images.length - 1) {
                const newIndex = currentIndex + 1;
                setCurrentIndex(newIndex);
                setTransformMediaValue(-newIndex * MediaGalleryWith);
            }
        };

        const goToPreviousImage = () => {
            if (currentIndex > 0) {
                const newIndex = currentIndex - 1;
                setCurrentIndex(newIndex);
                setTransformMediaValue(-newIndex * MediaGalleryWith);
            }
        };

        const numberOfImages = images.length;
        const trackWidth = `${numberOfImages * 100}%`;
        const wrapperWidth = `${(100 / numberOfImages).toFixed(5)}%`;
        
        return (
            <>
                <div id="media-gallery-frame" tabIndex="0">
                    <div id="media-gallery-track"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: trackWidth,
                            transform: `translate3d(${transformMediaValue}px, 0px, 0px)`,
                        }}>
                        {renderCarouselItem(images, wrapperWidth)}
                    </div>
                </div>
                <nav className="media-gallery-button-container">
                    {currentIndex > 0 && (                
                        <button type="button" title="Previous (right arrow)" onClick={goToPreviousImage}
                            className="media-carousel-back-button" 
                            aria-label="Back"
                        >
                            <svg role="presentation" viewBox="0 0 24 24" className="media-carousel-svg-arrow">
                                <path d="M15.422 16.078l-1.406 1.406-6-6 6-6 1.406 1.406-4.594 4.594z"></path>
                            </svg>
                        </button>               
                    )}
                    {currentIndex < images.length - 1 && ( 
                        <button type="button" title="Next (left arrow)" onClick={goToNextImage}
                            className="media-carousel-next-button" 
                            aria-label="Next"
                        >
                            <svg role="presentation" viewBox="0 0 24 24" className="media-carousel-svg-arrow">
                                <path d="M9.984 6l6 6-6 6-1.406-1.406 4.594-4.594-4.594-4.594z"></path>
                            </svg>
                        </button>  
                    )}              
                </nav>
            </>
        );
    }

    const renderMainImage = () => {

        if (!allImages) {
            return null;
        }

        const images = [];

        _.forEach(allImages, (image, index) => {            
            images.push({ source: image, id: index });
        });
        
        return (
            <>            
                <div className="media-gallery-container" id="media-gallery">
                    <div className="media-gallery-carousel-wrapper">
                        <div className="media-gallery-images-container">
                            <main className="media-gallery-images-pager">
                                {renderGalleryModal(images)}
                                {renderGallery(images)}
                            </main>
                        </div>
                        {renderGalleryButton()}
                    </div>                    
                </div>
            </>
        );

    };

    return renderMainImage();

};

export default MediaGalleryMobile;

MediaGalleryMobile.propTypes = {
    allImages: PropTypes.array,
};